module.exports = __webpack_public_path__ + "static/level_1.61457184.png";